import { Routes, Route, Navigate, useLocation } from 'react-router-dom';

import Landing from './ui/pages/Landing';
import Partners from './ui/pages/Partners';
import Conditions from './ui/pages/Conditions';
import Loading from './ui/pages/Loading';
import Result from './ui/pages/Result';
import Detail from './ui/pages/Detail';
import Step1 from './ui/pages/Conditions/Step1';
import Step3 from './ui/pages/Conditions/Step3';
import Step5 from './ui/pages/Conditions/Step5';
import Entry from './ui/pages/Entry';
import Working from './ui/pages/Working';
import RateCalc from './ui/pages/RateCalc';
import RateCalcAlone from './ui/pages/RateCalcAlone';
import Cardplate from './ui/pages/Cardplate';
import NotFound from './ui/pages/NotFound';

import Test from './ui/pages/Test/Test';
import TestKt from './ui/pages/Test/TestKt';
import TestLgu from './ui/pages/Test/TestLgu';
import Ui from './ui/pages/Test/Ui';
import Step1Dev from './ui/pages/Conditions/Step1Dev';
import NotiPreReg from './ui/pages/NotiPreReg';
import NotiPreInforms from './ui/pages/NotiPreInforms';
import ResultEntry from './ui/pages/ResultEntry';
import ResultStatus from './ui/pages/ResultStatus';
import Promotion from './ui/pages/Promotion';
import Home from './ui/pages/Home';
import PreviewPromotion from './ui/pages/PreviewPromotion';
import { Term } from './ui/pages/Term';
import { MtgConditions } from './ui/pages/Mtg/MtgConditions';
import { MtgPurpose } from './ui/pages/MtgConditions/MtgPurpose';
import { MtgNum } from './ui/pages/MtgConditions/MtgNum';
import { MtgSelect } from './ui/pages/MtgConditions/MtgSelect';
import { MtgTenant } from './ui/pages/MtgConditions/MtgTenant';
import { MtgIncome } from './ui/pages/MtgConditions/MtgIncome';
import { MtgCredit } from './ui/pages/MtgConditions/MtgCredit';
import { MtgConfirm } from './ui/pages/MtgConditions/MtgConfirm';
import { MtgResult } from './ui/pages/Mtg/MtgResult';
import { MtgLoading } from './ui/pages/Mtg/MtgLoading';
import { MtgDetail } from './ui/pages/Mtg/MtgDetail';
import { MtgCallTime } from './ui/pages/Mtg/MtgCallTime';
import { MtgResultComplete } from './ui/pages/Mtg/MtgResultComplete';
import { MtgResultStatus } from './ui/pages/Mtg/MtgResultStatus';
import ServiceAnswer from './ui/pages/SurveyAnswer';
import Step1Confirm from './ui/pages/Conditions/Step1Confirm';
import { IS_MTG_EXPOSED } from './application/types/types';

const Router = () => {
  const location = useLocation();
  const mtgHiddenRedirect = <Home />;

  return (
    <Routes>
      <Route
        path="/"
        element={<Navigate to={`/skt${location.search}`} replace />}
      />
      <Route
        path="/extlink"
        element={<Navigate to={`/skt${location.search}`} replace />}
      />

      <Route path="/:media" element={<Entry />}>
        {/* TODO: 라우터 전면 개편 필요.. */}
        <Route path="" element={<Home />} />
        <Route path="main" element={<Home />} />
        <Route path="nextMain" element={<Landing />} />
        {/* <Route path="credit" element={<Home />}>
              <Route path="main" element={<Landing />} /> */}
        <Route path="result-entry" element={<ResultEntry />} />
        {/* </Route> */}
        {/* <Route path="mtgMain" element={<MtgLanding />} /> */}
        <Route path="partners" element={<Partners />} />
        <Route path="loading" element={<Loading />} />
        <Route
          path="mtg/loading"
          element={IS_MTG_EXPOSED ? <MtgLoading /> : mtgHiddenRedirect}
        />
        <Route path="result" element={<Result />} />
        <Route
          path="mtg/result"
          element={IS_MTG_EXPOSED ? <MtgResult /> : mtgHiddenRedirect}
        />
        <Route path="result-status" element={<ResultStatus />} />
        <Route
          path="detail/:requestSeq/:preRequestDtlNo"
          element={<Detail />}
        />
        <Route
          path="mtg/detail/:requestSeq/:preRequestDtlNo"
          element={IS_MTG_EXPOSED ? <MtgDetail /> : mtgHiddenRedirect}
        />

        <Route path="term" element={<Term />} />
        <Route path="notiPreReg" element={<NotiPreReg />} />
        <Route path="promotion/:promoSeq" element={<Promotion />} />

        <Route path="notiPreInforms" element={<NotiPreInforms />} />
        <Route path="rateCalc" element={<RateCalc maxTerm={120} />} />
        <Route
          path="mtg/rateCalc"
          element={
            IS_MTG_EXPOSED ? <RateCalc maxTerm={480} /> : mtgHiddenRedirect
          }
        />

        <Route
          path="calltime"
          element={IS_MTG_EXPOSED ? <MtgCallTime /> : mtgHiddenRedirect}
        />
        <Route
          path="mtg/result-complete"
          element={IS_MTG_EXPOSED ? <MtgResultComplete /> : mtgHiddenRedirect}
        />
        <Route
          path="mtg/result-status"
          element={IS_MTG_EXPOSED ? <MtgResultStatus /> : mtgHiddenRedirect}
        />

        {/*신용대출 condition*/}
        <Route path="conditions" element={<Conditions />}>
          <Route path="1" element={<Step1 />} />
          <Route path="1/confirm" element={<Step1Confirm />} />
          <Route path="2" element={<Step1Dev />} />
          <Route path="3" element={<Step3 />} />
          <Route path="5" element={<Step5 />} />
        </Route>
        {/*주담대 condition*/}
        <Route
          path="mtg/conditions"
          element={IS_MTG_EXPOSED ? <MtgConditions /> : mtgHiddenRedirect}
        >
          <Route path="1" element={<MtgPurpose />} />
          <Route path="2" element={<MtgNum />} />
          <Route path="3" element={<MtgSelect />} />
          <Route path="4" element={<MtgTenant />} />
          <Route path="5" element={<MtgIncome />} />
          <Route path="6" element={<MtgCredit />} />
          <Route path="7" element={<MtgConfirm />} />
        </Route>
        <Route path="working" element={<Working />} />
        <Route
          path="survey/:surveyType/:targetSeq"
          element={<ServiceAnswer />}
        />
      </Route>
      <Route path="/kt/cardplate/:cardplateSeq" element={<Cardplate />} />
      <Route path="/skt/test" element={<Test />} />
      <Route path="/kt/test" element={<TestKt />} />
      <Route path="/lgu/test" element={<TestLgu />} />
      <Route
        path="/preview/promotion/:promoSeq"
        element={<PreviewPromotion />}
      />
      <Route path="/404" element={<NotFound />} />
      <Route path="/ui" element={<Ui />} />

      <Route path="/rateCalcAlone" element={<RateCalcAlone />} />
    </Routes>
  );
};

export default Router;
